<div class="task-assignment-list">
  @if (tasks().length === 0) {
    <p class="task-assignment-list__note">No tasks assigned</p>
  } @else {
    <ul class="task-assignment-list__list">
      @for (task of tasks(); track task.id) {
        <li class="task-assignment-list__row">
          <span class="task-assignment-list__code">{{ task.taskCode }}</span>
          <span class="task-assignment-list__name">{{ task.taskName }}</span>
        </li>
      }
    </ul>
  }
</div>
